import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Form Not Found</h1>
        <p className="error-message">
          The form link you're looking for doesn't exist or has been removed.
        </p>
        <p className="error-description">
          This could happen if:
        </p>
        <ul className="error-reasons">
          <li>The link was typed incorrectly</li>
          <li>The client ID is invalid</li>
          <li>The form has been deactivated</li>
        </ul>
        <div className="error-actions">
          <Link to="/form/iifd-surat" className="btn-primary">
            <i className="fa fa-home"></i>
            You want your business form
          </Link>
          <a href="https://proctur.com/website/contact-us" className="btn-secondary" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-envelope"></i>
            Contact Support
          </a>
        </div>
      </div>
      <div className="error-illustration">
        <i className="fa fa-exclamation-triangle"></i>
      </div>
    </div>
  );
}

export default NotFound;
